export function bustUrlCache(urlString) {
  const url = new URL(urlString, window.location.origin);
  url.searchParams.set('t', Date.now().toString());
  return url.toString();
}
//# sourceMappingURL=bustUrlCache.js.map